var exports = {
  "AX": "resultRow__BjR5Xh",
  "zx": "resultContent__clhnjI",
  "U1": "headerRow__gJ2Q1_",
  "Pf": "label__NERgaP",
  "I2": "languageCircleWrapper__VOT6Am",
  "jk": "stargazersLink__uyIXyf",
  "wv": "starIcon__M4-CxS",
  "iV": "actionsColumn__wIJsw_",
  "At": "starButtonWrapper__8PHLZO",
  "gf": "sponsorButtonWrapper__iJuIe-",
};

module.exports = exports;
